// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Resources } from '@shared/localizations/Resources';
import EditPositionScreenTemplate from '@front/templates/EditPositionScreenTemplate.html';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
import { TerceraWindowBase } from './TerceraWindowBase';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { editPositionScreenHandler } from '@shared/utils/AppHandlers';
import { DataCache } from '@shared/commons/DataCache';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class EditPositionScreen extends TerceraWindowBase {
    constructor() {
        super();
        this.isCentered = false;
    }
    getType() {
        return ScreensNames.EditPositionScreen;
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
    }
    localize() {
        void this.set('header', Resources.getResource('screen.editPosition.header'));
        const isModifyTabActive = this.get('isModifyTabActive');
        const childScreen = isModifyTabActive
            ? this.findComponent('modifyPositionScreen')
            : this.findComponent('terceraClosePositionScreen');
        if (!isNullOrUndefined(childScreen)) {
            childScreen.localize();
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    onChildFillByPosition(isModify) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isCentered && isModify === this.get('isModifyTabActive')) {
                yield this.set('visible', true);
                this.center();
                this.isCentered = true;
            }
        });
    }
    selectTab(dontChangeTabType, numericLinkName) {
        const pos = this.get('position');
        const placedFrom = this.get('placedFrom');
        let isModify = !this.get('isModifyTabActive');
        if (dontChangeTabType === true) {
            isModify = !isModify;
        }
        this.close();
        EditPositionScreen.show(pos.PositionId, placedFrom, numericLinkName, isModify);
    }
    static show(positionID, placedFrom, numericLinkName, isModify) {
        const position = DataCache.Trading.getPositionById(positionID);
        const allowed = isModify
            ? IsAllowed.IsPositionModifyingAllowed(position).Allowed
            : IsAllowed.IsPositionClosingAllowed(position, true).Allowed;
        if (!allowed) {
            return;
        }
        const screen = EditPositionScreen.getScreenByPositionID(positionID);
        if (!isNullOrUndefined(screen)) {
            // only one screen for one position
            screen.selectTab(isModify === screen.get('isModifyTabActive'), numericLinkName);
            screen.setFocus();
            return;
        }
        const parentScreen = MainWindowManager.Factory.addScreen(ScreensNames.EditPositionScreen);
        const forcedSelectedPanel = isModify
            ? parentScreen.findComponent('modifyPositionScreen')
            : parentScreen.findComponent('terceraClosePositionScreen');
        void parentScreen.set({
            position,
            placedFrom,
            isModifyTabActive: isModify,
            forcedSelectedPanel,
            activateNumericLinkName: numericLinkName
        });
        parentScreen.NotSkipNextTime = false; // TODO костыль ебаный
    }
    static getScreenByPositionID(positionID) {
        var _a;
        const keys = Object.keys(MainWindowManager.MainWindow.Controls);
        for (let i = keys.length - 1; i >= 0; i--) {
            const control = MainWindowManager.MainWindow.Controls[keys[i]];
            if (((_a = control === null || control === void 0 ? void 0 : control.getType) === null || _a === void 0 ? void 0 : _a.call(control)) === ScreensNames.EditPositionScreen) {
                const pos = control.get('position');
                if (!isNullOrUndefined(pos) && pos.PositionId === positionID) {
                    return control;
                }
            }
        }
        return null;
    }
    static editPositionScreenHandlerInitialize() {
        editPositionScreenHandler.show = EditPositionScreen.show;
    }
}
TerceraWindowBase.extendWith(EditPositionScreen, {
    data: function () {
        return {
            resizable: false,
            visible: false,
            width: 400,
            dockablePanel: false,
            showHeader: true,
            showFooter: true,
            items: null,
            header: 'Edit position',
            position: null,
            isModifyTabActive: null,
            placedFrom: null,
            numericLinkName: null,
            forcedSelectedPanel: null,
            style_addition_body: 'edit-position-screen'
        };
    },
    template: EditPositionScreenTemplate,
    childScreen: null
});
